export default __webpack_public_path__ + "static/media/Boots of the Hell Walker (nm).c0441d31.jpg";